import React from "react";
import Modal from "components/Modal";
import { useHistory } from "react-router";
import TabEdit from "containers/VideoDescriptionDetails/tabs/TabEdit";

const defaultVideoDescription = {
    title: "",
    description: "",
    published: false,
    videoUrl: ""
};

export default function VideoDescriptionCreate() {
    const history = useHistory();

    const onClose = () => history.push("/videos");

    const tabs = [
        {
            tabName: "edit",
            component: (
                <TabEdit
                    videoDescription={defaultVideoDescription}
                    createMode
                    onClose={onClose}
                />
            )
        }
    ];

    return (
        <div className="organisation-detail">
            <Modal
                title="Create Video Description"
                basePath="/videos/new"
                tabs={tabs}
                onClose={onClose}
            />
        </div>
    );
}
